// Imports from external sources
// React, i18next, Router, Mantine, Further Stuff
import { 
	Group,
	Text 
} from "@mantine/core";

// Imports from this projects
// Pages, Components, Features, Hooks
import { 
	useAuth 
} from "../../hooks/useAuth";

import { 
	LoginButton 
} from "./LoginButton";


// Define interfaces/types
export interface ProtectedRouteProps {
	children?: any;
}


// Export
export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
	const { authState } = useAuth();

	// handle users that are not authenticated
	if (!authState.isAuthenticated) {
		return (
			<Group>
				<LoginButton />
				<Text fz="sm">Please Log in to continue</Text>
			</Group>
		)
	}

	return children;
};